<template>
  <div id="genericReport">
    <!-- LISTAGEM POR VEÍCULO -->
    <div v-if="data.result">
      <div v-for="(res, index) in data.result" :key="index" class="mb-12 break-inside-avoid">
        <div class="bg-slate-800 text-white px-6 py-3 rounded-t-xl flex items-center justify-between">
          <span class="text-[10px] font-black uppercase tracking-[0.2em]">DETALHAMENTO DO VEÍCULO</span>
          <span class="text-sm font-bold uppercase">{{ res.vehicle.brand_desc }} {{ res.vehicle.model_desc }}</span>
        </div>

        <div class="border border-slate-200 border-t-0 rounded-b-xl overflow-hidden">
          <div class="p-6">
            <!-- INFO DO VEÍCULO -->
            <div class="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6 bg-slate-50 p-4 rounded-xl border border-slate-100">
              <div class="flex flex-col">
                <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">SUBSETOR</span>
                <span class="text-xs font-bold text-slate-700 uppercase">{{ res.vehicle.subsec_id || '---' }}</span>
              </div>
              <div class="flex flex-col">
                <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">PLACA</span>
                <span class="text-xs font-black text-orange-600 uppercase tracking-wider">{{ res.vehicle.vehicle_board }}</span>
              </div>
              <div class="flex flex-col">
                <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">TANQUE</span>
                <span class="text-xs font-bold text-slate-700 uppercase">{{ res.vehicle.vehicle_tank_capacity ? res.vehicle.vehicle_tank_capacity.toFixed(2) : '---' }} L</span>
              </div>
               <div class="flex flex-col lg:col-span-2">
                <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">SECRETARIA</span>
                <span class="text-xs font-bold text-slate-700 uppercase">{{ res.vehicle.sec_name || '---' }}</span>
              </div>
            </div>

            <!-- TABELA DE ABASTECIMENTOS -->
            <div class="overflow-x-auto">
              <table class="w-full text-left border-collapse">
                <thead>
                  <tr class="bg-slate-50 border-b border-slate-200 text-[#333]">
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider">Posto</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider">Combustível</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider">Data</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Preço Lic.</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Lts</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Total Lic.</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">KMs</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Rodado</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Média</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-center">Cupom</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(supply, sindex) in res.dataSupplies" :key="sindex" class="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                    <td class="p-3 text-[10px] font-bold text-slate-700 uppercase">{{ supply.provider_name }}</td>
                    <td class="p-3 text-[10px] text-slate-600 font-medium">{{ supply.item_description_desc }}</td>
                    <td class="p-3 text-[9px] text-slate-500">{{ convertDateTime(supply.datehour) }}</td>
                    <td class="p-3 text-[10px] text-slate-600 text-right">{{ supply.item_billing_price ? realMask(supply.item_billing_price.toFixed(2)) : 0 }}</td>
                    <td class="p-3 text-[10px] font-black text-slate-700 text-right">{{ supply.supply_liters_stocked ? realMaskII(supply.supply_liters_stocked.toFixed(3)) : 0 }}</td>
                    <td class="p-3 text-[10px] font-black text-slate-900 text-right font-mono">R$ {{ supply.supply_bidding_value ? realMask(supply.supply_bidding_value.toFixed(2)) : 0 }}</td>
                    <td class="p-3 text-[9px] text-slate-500 text-right">{{ supply.lastKm }} / {{ supply.supply_km }}</td>
                    <td class="p-3 text-[10px] text-slate-700 text-right font-bold">{{ supply.traveled ? supply.traveled.toFixed(0) : 0 }}</td>
                    <td class="p-3 text-[10px] text-orange-600 text-right font-black">{{ supply.average ? realMask(supply.average.toFixed(2)) : 0 }}</td>
                    <td class="p-3 text-[9px] text-slate-500 text-center uppercase">{{ supply.supply_coupon }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="bg-slate-50/80 font-black text-slate-800 border-t border-slate-200">
                    <td colspan="4" class="p-3 text-[10px] uppercase">TOTAIS DO VEÍCULO</td>
                    <td class="p-3 text-[10px] text-right text-slate-900">{{ res.totals.totalLiters ? convertDecimalValue(res.totals.totalLiters) : 0 }}</td>
                    <td class="p-3 text-[10px] text-right text-slate-900 font-mono">R$ {{ res.totals.totalValue ? convertDecimalValue(res.totals.totalValue) : 0 }}</td>
                    <td class="p-3 text-[10px] text-right">KMs: {{ res.totals.totalKm ? convertDecimalValue(res.totals.totalKm.toFixed(0)) : 0 }}</td>
                    <td></td>
                    <td class="p-3 text-[10px] text-right text-orange-600">Média: {{ res.totals.averageTotal ? realMask(res.totals.averageTotal.toFixed(2)) : 0 }}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <!-- RESUMO POR COMBUSTÍVEL DO VEÍCULO -->
            <div class="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
               <div v-for="(total, itotal) in res.finalTotals" :key="itotal" class="bg-white border border-slate-100 rounded-lg p-3 shadow-sm flex items-center justify-between">
                  <div class="flex flex-col">
                    <span class="text-[8px] font-black text-slate-400 uppercase tracking-widest">{{ total.item_description_desc }}</span>
                    <span class="text-[10px] font-bold text-slate-700">{{ total.totalLiters ? convertDecimalValue(total.totalLiters) : 0 }} L</span>
                  </div>
                  <span class="text-[11px] font-black text-emerald-600 font-mono">R$ {{ total.totalValues ? convertDecimalValue(total.totalValues) : 0 }}</span>
               </div>
            </div>
            
            <!-- RESUMO FINAL DO VEÍCULO -->
            <div class="mt-4 flex justify-end">
               <div class="bg-slate-800 rounded-xl px-6 py-3 flex gap-8 items-center border border-slate-700">
                  <div class="flex flex-col">
                    <span class="text-[9px] font-black text-slate-400 uppercase tracking-widest text-right">LITROS TOTAIS</span>
                    <span class="text-sm font-black text-white text-right">{{ res.resume.liters ? convertDecimalValue(res.resume.liters) : (res.totals.totalLiters ? convertDecimalValue(res.totals.totalLiters) : 0) }} L</span>
                  </div>
                  <div class="w-px h-6 bg-slate-700"></div>
                  <div class="flex flex-col">
                    <span class="text-[9px] font-black text-slate-400 uppercase tracking-widest text-right">VALOR TOTAL</span>
                    <span class="text-sm font-black text-orange-400 text-right font-mono">R$ {{ res.resume.value ? convertDecimalValue(res.resume.value) : (res.totals.totalValue ? convertDecimalValue(res.totals.totalValue) : 0) }}</span>
                  </div>
               </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="data.response">
      <div v-for="(res, index) in data.response" :key="index" class="mb-12 break-inside-avoid">
        <div class="bg-slate-800 text-white px-6 py-3 rounded-t-xl flex items-center justify-between">
          <span class="text-[10px] font-black uppercase tracking-[0.2em]">DETALHAMENTO DO VEÍCULO</span>
          <span class="text-sm font-bold uppercase">{{ res.vehicle.brand_desc }} {{ res.vehicle.model_desc }}</span>
        </div>

        <div class="border border-slate-200 border-t-0 rounded-b-xl overflow-hidden">
          <div class="p-6">
            <!-- INFO DO VEÍCULO -->
            <div class="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6 bg-slate-50 p-4 rounded-xl border border-slate-100">
              <div class="flex flex-col">
                <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">SUBSETOR</span>
                <span class="text-xs font-bold text-slate-700 uppercase">{{ res.vehicle.sec_name || '---' }}</span>
              </div>
              <div class="flex flex-col">
                <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">PLACA</span>
                <span class="text-xs font-black text-orange-600 uppercase tracking-wider">{{ res.vehicle.vehicle_board }}</span>
              </div>
              <div class="flex flex-col">
                <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">TANQUE</span>
                <span class="text-xs font-bold text-slate-700 uppercase">{{ res.vehicle.vehicle_tank_capacity ? res.vehicle.vehicle_tank_capacity.toFixed(2) : '---' }} L</span>
              </div>
               <div class="flex flex-col lg:col-span-2">
                <span class="text-[9px] font-black text-slate-400 uppercase tracking-tighter">PREFEITURA</span>
                <span class="text-xs font-bold text-slate-700 uppercase">{{ prefecture.prefecture_social_name || '---' }}</span>
              </div>
            </div>

            <!-- TABELA DE ABASTECIMENTOS -->
            <div class="overflow-x-auto">
              <table class="w-full text-left border-collapse">
                <thead>
                  <tr class="bg-slate-50 border-b border-slate-200 text-[#333]">
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider">Posto</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider">Combustível</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider">Data</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Preço Lic.</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Lts</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Total Lic.</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">KMs</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Rodado</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-right">Média</th>
                    <th class="p-3 text-[9px] font-black text-slate-500 uppercase tracking-wider text-center">Cupom</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(supply, sindex) in res.dataSupplies" :key="sindex" class="border-b border-slate-50 hover:bg-slate-50/50 transition-colors">
                    <td class="p-3 text-[10px] font-bold text-slate-700 uppercase">{{ supply.provider_name }}</td>
                    <td class="p-3 text-[10px] text-slate-600 font-medium">{{ supply.item_description_desc }}</td>
                    <td class="p-3 text-[9px] text-slate-500">{{ convertDateTime(supply.datehour) }}</td>
                    <td class="p-3 text-[10px] text-slate-600 text-right">{{ supply.supply_bidding_price ? realMask(supply.supply_bidding_price.toFixed(2)) : 0 }}</td>
                    <td class="p-3 text-[10px] font-black text-slate-700 text-right">{{ supply.supply_liters_stocked ? realMaskII(supply.supply_liters_stocked.toFixed(3)) : 0 }}</td>
                    <td class="p-3 text-[10px] font-black text-slate-900 text-right font-mono">R$ {{ supply.supply_bidding_value ? realMask(supply.supply_bidding_value.toFixed(2)) : 0 }}</td>
                    <td class="p-3 text-[9px] text-slate-500 text-right">{{ supply.lastKm }} / {{ supply.supply_km }}</td>
                    <td class="p-3 text-[10px] text-slate-700 text-right font-bold">{{ supply.traveled ? supply.traveled.toFixed(0) : 0 }}</td>
                    <td class="p-3 text-[10px] text-orange-600 text-right font-black">{{ supply.average ? realMask(supply.average.toFixed(2)) : 0 }}</td>
                    <td class="p-3 text-[9px] text-slate-500 text-center uppercase">{{ supply.supply_coupon }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="bg-slate-50/80 font-black text-slate-800 border-t border-slate-200">
                    <td colspan="4" class="p-3 text-[10px] uppercase">TOTAIS DO VEÍCULO</td>
                    <td class="p-3 text-[10px] text-right text-slate-900">{{ res.totals.totalLiters ? convertDecimalValue(res.totals.totalLiters) : 0 }}</td>
                    <td class="p-3 text-[10px] text-right text-slate-900 font-mono">R$ {{ res.totals.totalValue ? convertDecimalValue(res.totals.totalValue) : 0 }}</td>
                    <td class="p-3 text-[10px] text-right">KMs: {{ res.totals.totalKm ? convertDecimalValue(res.totals.totalKm) : 0 }}</td>
                    <td></td>
                    <td class="p-3 text-[10px] text-right text-orange-600">Média: {{ res.totals.averageTotal ? res.totals.averageTotal.toFixed(2) : 0 }}</td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- RESUMO FINAL DA CONSULTA (data.finalResume) -->
      <div v-if="data.finalResume" class="mt-12 break-inside-avoid">
        <div class="bg-slate-800 text-white px-6 py-3 rounded-t-xl">
          <span class="text-[10px] font-black uppercase tracking-[0.2em]">RESUMO CONSOLIDADO POR COMBUSTÍVEL</span>
        </div>
        <div class="border border-slate-200 border-t-0 rounded-b-xl p-6 bg-slate-50/30">
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div v-for="(tResume, tr) in data.finalResume" :key="tr" class="bg-white p-5 rounded-xl border border-slate-100 shadow-sm flex flex-col justify-between">
              <span class="text-[10px] font-black text-slate-400 uppercase tracking-[0.1em] mb-4 pb-2 border-b border-slate-50">{{ tResume.item_description_desc }}</span>
              <div class="flex items-end justify-between">
                <div class="flex flex-col">
                  <span class="text-[9px] font-bold text-slate-400 uppercase">Litros</span>
                  <span class="text-base font-black text-slate-700">{{ convertDecimalValue(tResume.totalLiters) }} L</span>
                </div>
                <div class="flex flex-col items-end">
                  <span class="text-[9px] font-bold text-slate-400 uppercase text-right">Valor Total</span>
                  <span class="text-base font-black text-emerald-600 font-mono text-right">R$ {{ convertDecimalValue(tResume.totalValues) }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- TOTAL GERAL (data.finalTotalResume) -->
          <div v-if="data.finalTotalResume" class="mt-8 pt-8 border-t border-slate-200 flex justify-end">
            <div class="bg-slate-800 rounded-2xl px-10 py-5 flex gap-12 items-center shadow-xl border border-slate-700">
              <div class="flex flex-col">
                <span class="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] text-right mb-1">TOTAL GERAL LITROS</span>
                <span class="text-2xl font-black text-white text-right">{{ convertDecimalValue(data.finalTotalResume.totalLiters) }} L</span>
              </div>
              <div class="w-px h-12 bg-slate-700"></div>
              <div class="flex flex-col">
                <span class="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] text-right mb-1">TOTAL GERAL VALOR</span>
                <span class="text-2xl font-black text-orange-400 text-right font-mono">R$ {{ convertDecimalValue(data.finalTotalResume.totalValue) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from "@/mixins/helpers";

export default {
  props: ["data", "filter", "prefecture"],
  mixins: [helpers],
  methods: {
    initialize() {
      this.helpers;
    },
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 1px solid rgb(17, 17, 17);
}
</style>